import { useMutation } from "@apollo/client";
import { GAME_CREATE, GAME_UPDATE } from "graphql/mutation/game-gql";

const useMutationGameCreateUpdate = (id) => {
  const [_setGameCreateUpdate, { loading }] = useMutation(id ? GAME_UPDATE : GAME_CREATE);

  return {
    _setGameCreateUpdate,
    loadingMutationGameCreateUpdate: loading,
  };
};

export default useMutationGameCreateUpdate;
